import { SelectControl, Button, ButtonGroup, ToggleControl, PanelBody, PanelRow, Tooltip } from "@wordpress/components";
import { useEffect } from "react";
import { __ } from "@wordpress/i18n";

import BMediaUpload from "../../../../../components/BMediaUpload/BMediaUpload";
import { BControlPro } from "../../../../../../../wp-utils/v1/components/";

const ModelForm = ({ attributes, setAttributes }) => {
  const { model, models, multiple, isPremium, currentViewer, O3DVSettings } = attributes;

  const updateModels = (key, value, index) => {
    const newModels = [...models];
    newModels[index][key] = value;
    setAttributes({ models: newModels });
  };

  const modelViewer = ["gltf", "glb"].includes(model.ext || "glb");

  // useEffect(() => {
  //   setAttributes({ O3DVSettings: { ...O3DVSettings, camera: null } });
  // }, [model]);

  return (
    <PanelBody title={__("Model", "model-viewer")}>
      <PanelRow>
        <strong>{__("3D Viewer", "model-viewer")}</strong>
        <ButtonGroup>
          <Tooltip delay={100} text={__("Support only .glb, .glTF", "model-viewer")}>
            <Button variant={currentViewer === "modelViewer" ? "primary" : ""} onClick={() => setAttributes({ currentViewer: "modelViewer" })}>
              {__("Lite", "model-viewer")}
            </Button>
          </Tooltip>
          <Tooltip
            text={__("Support .obj, .3ds, .stl, .ply, .gltf, .off, .3dm, .fbx, .dae, .wrl, .3mf, amf, ifc, .brep, .step, .iges, .fcstd, and .bim  file types", "model-viewer")}
            delay={100}
          >
            <Button variant={currentViewer === "O3DViewer" ? "primary" : ""} onClick={() => setAttributes({ currentViewer: "O3DViewer" })}>
              {__("Advanced", "model-viewer")}
            </Button>
          </Tooltip>
        </ButtonGroup>
      </PanelRow>

      <p className="bp3d_help components-base-control__help">
        <i>
          The Lite Viewer prioritizes .glb and .glTF files with robust features, while the Advanced Viewer, supporting{" "}
          <Tooltip delay={100} text="obj, .3ds, .stl, .ply, .gltf, .off, .3dm, .fbx, .dae, .wrl, .3mf, amf, ifc, .brep, .step, .iges, .fcstd, .bim">
            <strong>
              <u> almost every file types</u>
            </strong>
          </Tooltip>
          , has a more streamlined functionality.
        </i>
      </p>
      {/* {modelViewer && ( */}
      <PanelRow>
        <BControlPro
          label={__("Use Multiple Model?", "model-viewer")}
          isPremium={isPremium}
          Component={ToggleControl}
          checked={multiple}
          onChange={() => setAttributes({ multiple: !multiple })}
        />
      </PanelRow>
      {/* )} */}
      {multiple && isPremium ? (
        <>
          {models?.map((model, index) => (
            <PanelBody key={index} title={__("Model ", "model-viewer") + parseInt(index + 1)} initialOpen={false} className="modelPanel">
              <BMediaUpload
                value={model?.modelUrl}
                placeholder={__("Model URL", "model-viewer")}
                onSelect={(modelUrl) => updateModels("modelUrl", modelUrl, index)}
                type={["model/gltf-binary"]}
                label={__("Model URL", "model-viewer")}
              />
              <BMediaUpload
                value={model?.poster}
                placeholder={__("Model Poster", "model-viewer")}
                onSelect={(poster) => updateModels("poster", poster, index)}
                type={["image"]}
                label={__("Model Poster", "model-viewer")}
              />
              {currentViewer === "modelViewer" && (
                <>
                  <PanelRow>
                    <label>{__("Use Decoder", "model-viewer")}</label>
                    <SelectControl
                      options={[
                        { label: "None", value: "none" },
                        { label: "Draco", value: "draco" },
                      ]}
                      value={model?.decoder}
                      onChange={(decoder) => updateModels("decoder", decoder, index)}
                    />
                  </PanelRow>
                  {model?.decoder === "draco" && (
                    <>
                      <BMediaUpload
                        value={model?.binFile}
                        placeholder={__("Bin File", "model-viewer")}
                        onSelect={(binFile) => updateModels("binFile", binFile, index)}
                        type={["application/octet-stream"]}
                        label={__("Bin File", "model-viewer")}
                      />
                    </>
                  )}
                </>
              )}
              {models.length !== 1 && (
                <PanelRow className="modelRemover">
                  <Button
                    variant="primary"
                    onClick={() => {
                      const newModels = [...models];
                      newModels.splice(index, 1);
                      setAttributes({ models: newModels });
                    }}
                  >
                    {__("Remove", "model-viewer")}
                  </Button>
                </PanelRow>
              )}
            </PanelBody>
          ))}

          <PanelRow>
            <Button
              variant="primary"
              onClick={() => {
                const newModels = [...models];
                newModels.push({});
                setAttributes({ models: newModels });
              }}
            >
              {__("Add New", "model-viewer")}
            </Button>
          </PanelRow>
        </>
      ) : (
        <>
          <BMediaUpload
            value={model?.modelUrl}
            placeholder={__("Model URL", "model-viewer")}
            onSelect={(modelUrl) => {
              setAttributes({ model: { ...model, modelUrl, ext: modelUrl.split(".")?.[modelUrl.split(".").length - 1] }, O3DVSettings: { ...O3DVSettings, camera: null } });
            }}
            type={[
              "model/gltf-binary",
              "model/obj",
              "application/octet-stream",
              "application/x-3ds",
              "application/vnd.ms-pki.stl",
              "text/vnd.in3d.3dml",
              "application/collada+xml",
              "model/vrml",
              "application/vnd.ms-3mfdocument",
            ]}
            label={__("Model URL", "model-viewer")}
          />
          {currentViewer === "modelViewer" && (
            <>
              <BMediaUpload
                value={model?.poster}
                placeholder={__("Model Poster", "model-viewer")}
                onSelect={(poster) => setAttributes({ model: { ...model, poster } })}
                type={["image"]}
                label={__("Model Poster", "model-viewer")}
              />
              <PanelRow>
                <label>{__("Use Decoder", "model-viewer")}</label>
                <SelectControl
                  options={[
                    { label: "None", value: "none" },
                    { label: "Draco", value: "Draco" },
                  ]}
                  value={model?.decoder}
                  onChange={(decoder) => setAttributes({ model: { ...model, decoder } })}
                />
              </PanelRow>
              {model?.decoder === "Draco" && (
                <>
                  <BMediaUpload
                    value={model?.binFile}
                    placeholder={__("Bin File", "model-viewer")}
                    onSelect={(binFile) => setAttributes({ model: { ...model, binFile } })}
                    type={["application/octet-stream"]}
                    label={__("Bin File", "model-viewer")}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </PanelBody>
  );
};

export default ModelForm;
